"use client";
/* PersonCard — Double-Bezel architecture with hover lift */
import React from "react";

interface PersonCardProps {
  name: string;
  role: string;
  profileImage: string;
  bio: string;
  className?: string;
}

export const PersonCard = ({
  name,
  role,
  profileImage,
  bio,
  className,
}: PersonCardProps) => {
  return (
    <article
      className={`group rounded-[var(--radius-xl)] border border-[var(--color-border)] bg-[var(--color-surface-elevated)] p-2 transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] hover:-translate-y-1 hover:shadow-[0_32px_64px_rgba(0,0,0,0.08)] ${className || ""}`}
    >
      <div className="overflow-hidden rounded-[var(--radius-lg)]">
        <img
          src={profileImage}
          alt={name}
          className="h-56 w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.32,0.72,0,1)] group-hover:scale-105"
        />
      </div>
      <div className="p-6">
        <h3 className="mb-1 text-lg font-bold tracking-tight text-[var(--color-ink)]">
          {name}
        </h3>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.15em] text-[var(--color-accent)]">
          {role}
        </p>
        <p className="text-sm leading-relaxed text-[var(--color-muted)]">
          {bio}
        </p>
      </div>
    </article>
  );
};
